"use client";
import ProductCard from "@/app/views/popular/components/ProductCard";
import AccountMenu from "@/components/AccountMenu";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { CardDescription, CardTitle } from "@/components/ui/card";
import { WishlistContext } from "@/context/WishlistContext";
import { Heart, ShoppingBag } from "lucide-react";
import { useRouter } from "next/navigation";
import { useContext, useEffect, useState } from "react";

const Wishlist = () => {
  const router = useRouter();
  const { wishlist, toggleWishlist } = useContext(WishlistContext);
  const [wishlistProducts, setWishlistProducts] = useState([]);

  useEffect(() => {
    setWishlistProducts(wishlist);
  }, [wishlist]);

  return (
    <div className="container mx-auto max-w-5xl py-8 px-4 sm:px-6">
      <AccountMenu />
      <div className="border-b border-brand-light pb-6 mb-6">
        <CardTitle className="text-lg flex items-center gap-2 text-brand-navy">
          <span className="w-8 h-8 rounded-lg bg-brand-light flex items-center justify-center shadow-brand-sm">
            <Heart className="h-4 w-4 text-brand-sky" />
          </span>
          Your Wishlist
        </CardTitle>
        <CardDescription className="text-muted-foreground mt-2">
          You currently have {wishlistProducts?.length || 0} products saved in
          your wishlist. Add more items to expand your selection before making
          your purchase.
        </CardDescription>
      </div>

      {wishlistProducts?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <div className="bg-brand-light rounded-full p-6 mb-4">
            <Heart className="h-12 w-12 text-brand-sky" strokeWidth={1} />
          </div>
          <h3 className="text-lg font-semibold text-brand-navy">
            No Wishlists Found
          </h3>
          <p className="text-sm text-muted-foreground mt-1 max-w-sm">
            There is no item saved yet. Start adding your favorite products.
          </p>
          <Button
            onClick={() => router.push("/")}
            className="mt-4 gradient-primary hover:opacity-95 text-white font-semibold rounded-xl px-6 h-11 shadow-brand hover:shadow-brand-lg transition-all"
          >
            <ShoppingBag className="h-4 w-4 mr-2" />
            Browse Products
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {wishlistProducts?.map((product, i) => (
            <div className="relative group border" key={i}>
              <Badge
                onClick={() => toggleWishlist(product)}
                className="absolute z-10 top-2 left-2 cursor-pointer bg-red-500 text-white text-xs px-2 py-1 shadow-brand-sm transition-colors"
              >
                Remove
              </Badge>
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;